// Module
var code = "<!-- ko if: text -->\n<!-- ko text: text -->\n<!-- /ko -->\n<!-- /ko -->\n\n<!-- ko if: html -->\n<div data-bind=\"html: html\"></div>\n<!-- /ko -->\n\n<!-- ko ifnot: text -->\n<!-- ko template: { nodes: $componentTemplateNodes } -->\n<!-- /ko -->\n<!-- /ko -->\n";
// Exports
module.exports = code;